module.exports = __webpack_public_path__ + "static/media/danielle-mckellar.6961859a.jpeg";